import React from 'react'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import ProductStockLimitContainerUi from './ui/ProductStockLimitContainerUi'
import ProductStockLimitInnerContainerUi from './ui/ProductStockLimitInnerContainerUi'

interface ProductStockLimitProps {
  stockLimit: number
  showStockLimit?: boolean
}

function ProductStockLimit({
  stockLimit,
  showStockLimit,
}: ProductStockLimitProps) {
  const { t } = useTypedTranslation('common')
  return (
    <>
      {showStockLimit && (
        <ProductStockLimitContainerUi>
          {t('entity.product.stock_limit_label')}:
          <ProductStockLimitInnerContainerUi>
            {t('entity.product.stock_limit_title_icu', { limit: stockLimit })}
          </ProductStockLimitInnerContainerUi>
        </ProductStockLimitContainerUi>
      )}
    </>
  )
}

export default ProductStockLimit
